"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TitleWrapper = exports.TitleRowWrapper = exports.Checkbox = exports.SectionLine = exports.Title = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const colors_1 = require("../../../theme/colors");
exports.Title = styled_components_1.default.h2 `
  color: ${colors_1.GREY4};
  margin: 0;
`;
exports.SectionLine = styled_components_1.default.hr `
  border: 1px solid ${colors_1.LIGHT_GREY};
  width: 100%;
  margin: 8px 0 16px 0;
`;
exports.Checkbox = styled_components_1.default.input ``;
exports.TitleRowWrapper = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
exports.TitleWrapper = styled_components_1.default.div `
  display: flex;
`;
//# sourceMappingURL=SectionHeader.styles.js.map